export { WithSocialIconsVariation as default } from './WithSocialIconsVariation';
